import { FC } from 'react'

import {
  ConfigFormTemplate,
  InputSelectControlField
} from 'Automations/nodeDefinitions/components'
import { startNodeTriggerTargetDefinition } from '..'
import { Config } from '.'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import {
  useSetDefaultAutomationName,
  useStartNodeTriggerOptions
} from '../hooks'
import { useAutomationId } from 'Automations/automationEditor/hooks'

export const StartQuoteRequiresApprovalConfigForm: FC<ConfigFormProps> = ({
  nodeId
}) => {
  const { nodeData, updateNodeType, definition, validationErrors } =
    useNode<Config>({ nodeId })
  const options = useStartNodeTriggerOptions()
  const { isNewAutomation } = useAutomationId()
  const { setDefaultAutomationName } = useSetDefaultAutomationName()

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Type">
        <InputSelectControlField
          data-testid="automations.editor.configForm.start.trigger"
          value={nodeData.trigger}
          placeholder="Select type..."
          options={options}
          onChange={trigger => {
            setDefaultAutomationName(trigger as Config['trigger'])
            updateNodeType(
              startNodeTriggerTargetDefinition[trigger as Config['trigger']]
            )
          }}
          validationErrors={validationErrors.trigger}
          disabled={!isNewAutomation}
        />
      </ConfigFormTemplate.Row>
    </ConfigFormTemplate>
  )
}
